import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
      loading: false,
      company: sessionStorage.getItem('company'),
      appInfo: JSON.parse(localStorage.getItem('appInfo')) || null,
      shopInfo: JSON.parse(localStorage.getItem('shopInfo')) || null,
      menuInfo: JSON.parse(localStorage.getItem('menuInfo')) || null,
      mainHeight: null,
      shopIds: null,
      switchShopInfo: false,
      SwitchShopflag: false,
      memberMobile: null,
      menuPage: JSON.parse(localStorage.getItem("menuPage")),
      curentUrl: localStorage.getItem("setCurentUrl") || '',
    },
    getters: {
        AppInfo: state => state.appInfo,
        ShopInfo: state => state.shopInfo,
        MenuInfo: state => state.menuInfo,
        SwitchShopInfo: state => state.switchShopInfo,
        SwitchShopflag: state => state.SwitchShopflag,
        MainHeight: state => state.mainHeight,
        ShopIds: state => state.shopIds,
      MemberMobile: state => state.memberMobile,
      menuPage: state => state.menuPage,
      curentUrl: state => state.curentUrl,
      
    },
    mutations: {
        setSwitchShopInfo(state, value) {
            if (value) {
                state.switchShopInfo = value;
                sessionStorage.setItem('switchShopInfo', value);
            } else {
                sessionStorage.removeItem('switchShopInfo');
                state.switchShopInfo = '';
            }
        },
        setMemberMobile(state, value) {
            if (value) {
                localStorage.setItem('historyMobile', value);
            }
            state.memberMobile = value;

            if (value) {
                let arr = [];
                if (JSON.parse(localStorage.getItem("historyMobileList"))) {
                    arr = JSON.parse(localStorage.getItem("historyMobileList"));
                }
                if (arr.includes(value)) {
                    arr = arr.filter(function(item) {
                        return item !== value
                    });
                    arr.unshift(value);
                    localStorage.setItem("historyMobileList", JSON.stringify(arr));
                    return;
                }
                if (arr.length >= 3) {
                    arr.pop()
                }
                arr.unshift(value);
                localStorage.setItem("historyMobileList", JSON.stringify(arr));
            }
        },
        setShopId(state, value) {
            localStorage.setItem('shopIds', value);
            state.shopIds = value;
        },
        ifLoading(state, flag) {
            state.loading = flag
        },
        setMainHeight(state, value) {
            state.mainHeight = value;
        },
        setShowMenus(state, info) {
            localStorage.setItem('menuInfo', JSON.stringify(info));
            state.menuInfo = info;
        },
        setShopMessage(state, info) {
            if (info) {
                localStorage.setItem('shopInfo', JSON.stringify(info));
                state.shopInfo = info;
                state.SwitchShopflag = !state.SwitchShopflag
            }
      },
      setCurentPage(state, info) {
        if (info) {
            localStorage.setItem('menuPage', JSON.stringify(info));
            state.menuPage = info;
        }
      },
      setCurentUrls(state, info) {
        if (info) {
          console.log(info);
          localStorage.setItem('setCurentUrl', info);
            state.curentUrl = info;
        }
      },
        setLoginUser(state, info) {
            if (info) {
                localStorage.setItem('appInfo', JSON.stringify(info));
                state.appInfo = info;
            } else {
                localStorage.removeItem('appInfo');
                state.appInfo = null;
            }
        },
        setCompany(state, value) {
            if (value) {
                state.company = value;
                sessionStorage.setItem('company', value);
            } else {
                sessionStorage.removeItem('company');
                state.company = '';
            }
        }
    }
});

export default store;